import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import { api } from './mixins/api.js'
const backend = api.methods // FIXME: This is definitively bad style

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    /*
    Mapping: lempos -> group object, where a group consist of
    - pattern
    - core_indexes
    - collocation_groups
    In addition to used-defined groups, there are three pre-defined ones:
    - correct: all reviewed but not yet grouped collocations
    - most_frequent: most frequent candidates (top-n)
    - highest_scoring: highest scoring candidates (top-n)
    */
    groups: {},
    /*
    Lower bound for the size of topn lists (most frequent / highest scoring) for
    every qualified pattern. When bound is almost reached, 2*N new colls are fetched */
    topnMinSize: 10,
    /*
    Mapping: (lempos, pattern) -> collocation object. The collocation objects contains:
    - lempos
    - pattern
    - freq
    - (score)
    - correct-instances ??
    - unrated-instances ?? */
    collocations: {},
    /*
    Name of currently selected collocation */
    selectedCollocation: null,
    /*
    Example sentences */
    examples: {},
    /*
    A firebase.User object */
    user: null
  },
  getters: {
    getGroupsForQualifiedPattern: (state) => (lempos, pattern, coreIndexes) => {
      const g = state.groups[lempos]
      if (!g) {
        console.log('No groups for lempos ' + lempos)
        return null
      }
      const group = g.find(g => (g.pattern === pattern && g.core_indexes.join(',') === coreIndexes.join(',')))
      if (!group) {
        console.log('No groups for pattern ' + pattern + ' and coreIndexes ' + coreIndexes)
      }
      return group
    },
    getSemanticGroupForQualifiedPattern: (state, getters) => (lempos, pattern, coreIndexes, name) => {
      const g = getters.getGroupsForQualifiedPattern(lempos, pattern, coreIndexes)
      console.log(g)
      if (!g) {
        return null
      }
      const group = g.semanticGroups.find(g => (g.name === name))
      if (!group) {
        console.log('No group named ' + name)
      }
      return group
    },
    getCollocation: (state) => (lempos, pattern) => {
      const key = lempos + '+' + pattern
      console.log('getCollocation: ' + key)
      return state.collocations[key]
    }
  },
  mutations: {
    updateSemanticGroups (state, { lempos, pattern, coreIndexes, groups }) {
      const group = state.groups[lempos].find(g => (g.pattern === pattern && g.core_indexes.join(',') === coreIndexes.join(',')))
      group.semantic_groups = groups
    },
    updateCorrectUngrouped (state, { lempos, pattern, coreIndexes, colls }) {
      const group = state.groups[lempos].find(g => (g.pattern === pattern && g.core_indexes.join(',') === coreIndexes.join(',')))
      group.correct_ungrouped = colls
    },
    selectCollocation (state, coll) {
      state.selectedCollocation = coll
    },
    updateGroups (state, { lempos, groups }) {
      console.log('updateGroups:')
      console.log(groups)
      Vue.set(state.groups, lempos, groups)
    },
    updateUnratedCollocations (state, { lempos, pattern, coreIndexes, collocations }) {
      var g = state.groups[lempos].find(g => g.pattern === pattern && g.core_indexes[0] === coreIndexes[0])
      g.unrated_by_freq = collocations
    },
    /**
     * Adds an empty semantic group
     * @param {name:string, groups:string} obj
     * @param {string} obj.name Name of the new semantic group
     * @param {string} obj.groups The semantic groups object, the new group should be added to
     */
    addSemanticGroup (state, { semanticGroups }) {
      semanticGroups.push(
        { name: '', collocations: [], visible: true, id: Math.random().toString(36).substring(2, 15) })
    },
    updateCollocations (state, { lempos, pattern, collocation }) {
      const key = lempos + '+' + pattern
      console.log('updateCollocation: ' + key)
      console.log(collocation)
      Vue.set(state.collocations, key, collocation)
    },
    updateExamples (state, { ref, example }) {
      console.log('updateExamples: ' + ref)
      // console.log(example)
      Vue.set(state.examples, ref, example)
      console.log(state.examples[ref])
    },
    rateExample (state, { example, coll, isGood }) {
      console.log('rateExample')
      console.log({ example, coll, isGood })
      coll.unrated_instances.splice(coll.unrated_instances.findIndex(e => e.ref === example.ref), 1)
      if (isGood) {
        coll.good_instances.push(example)
      }
    },
    rateCollocation (state, { lempos, pattern, isGood }) {
      console.log('rateCollcation')
      console.log({ lempos, pattern, isGood })
      const key = lempos + '+' + pattern
      Vue.set(state.collocations[key], 'rating', isGood)

      // The collocation is part of several pattern groups (e.g. NOUN + adj and noun + ADJ)
      // In all locations, it must be moves from unrated_by_freq or unrated_by_score to correct_ungrouped.
      console.log(lempos.split(' '))
      for (const [idx, lp] of lempos.split(' ').entries()) {
        console.log('Getting patterGroups for ' + lp)
        const patternGroups = state.groups[lp]
        if (!patternGroups) {
          continue
        }
        const patternGroup = patternGroups.find(g => g.pattern === pattern && g.core_indexes[0] === idx)
        console.log(patternGroup)
        if (isGood) {
          patternGroup.correct_ungrouped.push(lempos)
        }
        for (const unratedList of [patternGroup.unrated_by_freq, patternGroup.unrated_by_score]) {
          const idx = unratedList.findIndex(c => c === lempos)
          if (idx >= 0) {
            unratedList.splice(idx, 1)
          }
        }
      }
    },
    updateUser (state, user) {
      state.user = user
    }
  },
  actions: {
    /**
    * Fetches collocations for given core lempos from server
    * @param {string} lempos
    */
    async loadGroups ({ state, commit }, { lempos }) {
      // Only load once
      if (state.groups.hasOwnProperty(lempos)) {
        // console.log('Not loading groups again for lempos ' + lempos)
        return
      }
      // Setting group to null, so that consumers know we are fetching the datas
      commit('updateGroups', { lempos, groups: null })
      var response = await backend.getCollocationSummary({
        lempos,
        correct_ungrouped: true,
        unrated_by_freq: true,
        n: state.topnMinSize * 2,
        user: state.user
      })
      var patternGroups = response.data
      // Add id field
      for (var patternGroup of patternGroups) {
        for (var g of patternGroup.semantic_groups) {
          g.id = Math.random().toString(36).substring(2, 15)
        }
      }
      commit('updateGroups', { lempos, groups: patternGroups })
    },
    /**
     * Fetchtes unrated collocations for given qualified pattern.
     * Get topn by freq, does not touch topn by score
     */
    async loadUnratedCollocations ({ state, commit, getters }, { lempos, pattern, coreIndexes }) {
      const g = getters.getGroupsForQualifiedPattern(lempos, pattern, coreIndexes)
      if (g.unrated_by_freq.length > state.topnMinSize + 1) {
        console.log('Not loading unrated collocations for ' + lempos + ' ' + pattern + '@' + coreIndexes[0])
        return
      }
      console.log('Loading unrated collocations for ' + lempos + ' ' + pattern + '@' + coreIndexes[0])
      const r = await backend.getUnratedCollocations({
        lempos,
        pattern,
        core_indexes: coreIndexes,
        n: state.topnMinSize * 2,
        sort_by: 'freq',
        user: state.user
      })
      commit('updateUnratedCollocations', { lempos, pattern, coreIndexes, collocations: r.data })
    },
    async updateSemanticGroups ({ state, commit }, { lempos, pattern, coreIndexes, groups }) {
      commit('updateSemanticGroups', { lempos, pattern, coreIndexes, groups })
      // Remove id field
      var groupsWithoutId = groups.map((g) => { var { id, ...other } = g; return other })
      await backend.updateSemanticGroups({
        lempos,
        pattern,
        core_indexes:
        coreIndexes,
        groups: groupsWithoutId,
        user: state.user
      })
    },

    /**
    * Fetches collocations for given core lempos from server
    * @param {string} lempos The lempos of the collocation to fetch
    * @param {string} pattern The pattern of the collocation to fetch
    */
    async loadCollocation ({ state, commit }, { lempos, pattern }) {
      const key = lempos + '+' + pattern
      // Only load once
      if (state.collocations.hasOwnProperty(key)) {
        // console.log('Not loading again collocation ' + key)
        return
      }
      // Setting group to null, so that consumers know we are fetching the datas
      commit('updateCollocations', { lempos, pattern, collocation: null })
      var response = await backend.getCollocation({
        lempos,
        pattern,
        user: state.user
      })
      commit('updateCollocations', { lempos, pattern, collocation: response.data })
    },
    async rateCollocation ({ state, commit, dispatch }, { lempos, pattern, isGood }) {
      // If the collocation has not yet been loaded, load it
      const key = lempos + '+' + pattern
      if (!state.collocations[key]) {
        await dispatch('loadCollocation', { lempos, pattern })
      }

      // Update store and send rating to backend
      commit('rateCollocation', { lempos, pattern, isGood })
      await backend.rateCollocation({ lempos, pattern, rating: isGood, user:state.user})

      // Eventually fetch new unrated cols
      for (const [idx, lp] of lempos.split(' ').entries()) {
        if (!state.groups[lp]) { continue }
        await dispatch('loadUnratedCollocations', { lempos: lp, pattern, coreIndexes: [idx] })
      }
    },
    async loadExample ({ state, commit }, { ref }) {
      // Only load once
      if (state.examples.hasOwnProperty(ref)) {
        // console.log('Not loading again example ' + ref)
        return
      }
      // Setting group to null, so that consumers know we are fetching the datas
      commit('updateExamples', { ref, example: null })
      var response = await backend.getExample({ref, user: state.user})
      commit('updateExamples', { ref, example: response.data })
    },
    async rateExample ({ state, commit, dispatch }, { example, coll, isGood }) {
      commit('rateExample', { example, coll, isGood })
      await backend.rateInstance({
        lempos: coll.lempos_string,
        pattern: coll.pattern,
        ref: example.ref,
        rating: isGood,
        user: state.user
      })
      // CHECK: right place?
      if (coll.rating !== true && isGood) {
        dispatch('rateCollocation', { lempos: coll.lempos_string, pattern: coll.pattern, isGood: true })
      }
    }
  }
})
